import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { setOptions, localeDe, MbscModule } from '@mobiscroll/angular';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/service/auth.service';

setOptions({
  locale: localeDe,
  theme: 'ios',
  themeVariant: 'light'
});
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, MbscModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  private loginSubscription!: Subscription;
  apiUrl = environment.apiUrl;
  testUrl = 'https://test.api.tridimo.de/api/'
  ProductionUrl = 'https://api.tridimo.de/api/'
  devUrl = 'https://dev.api.tridimo.de/api/'
  authService = inject(AuthService);
  router = inject(Router);
  formIsVAlid: boolean = false

  protected loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  })

   /**
   * Wird beim Absenden des Login-Formulars ausgeführt.
   * Prüft die Validität und sendet Login-Daten an den AuthService.
   * Speichert Token und Userdaten bei erfolgreichem Login.
   */
  onSubmit() {
    if (this.loginForm.valid) {
      
      this.authService.login(this.loginForm.value).subscribe(
        (data: any) => {
          sessionStorage.setItem('authToken', data.token);
          const userData = {
            active: data.user.active,
            email: data.user.email,
            firstName: data.user.firstName,
            id: data.user.id,
            kuerzel: data.user.kuerzel,
            lastLogin: data.user.lastLogin,
            lastName: data.user.lastName,
            role: data.user.role, 
            startDate: data.user.startDate,
          };


          sessionStorage.setItem('role', data.user.role);
          sessionStorage.setItem('firstName', data.user.firstName);
          sessionStorage.setItem('lastName', data.user.lastName);
          //sessionStorage.setItem('id','4');

          localStorage.setItem('role', data.user.role);
          localStorage.setItem('firstName', data.user.firstName);
          localStorage.setItem('lastName', data.user.lastName);
          sessionStorage.setItem('roleRoute', 'main-route')
          sessionStorage.setItem('permissions', data.user.permissions)
          if (this.authService.isLoggedIn()) {
            if(data.user.role === 'Admin' || data.user.role === 'Buero' || data.user.role === 'Personal') {
              this.router.navigate(['dashboard'])
            } 
          }
        },
        (error: any) => {
          if (error.status === 400) {
            console.log('Login','Ungültige Anmeldedaten. Bitte überprüfen deine Eingaben.');
          } else {
            console.log('Login','Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut oder kontaktiere den Support.');
          }
        }
      );
    } else {
      console.log('Login','Bitte fülle das Formular aus.');
    }
  }
}

